import React from 'react';
import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

const RectangularChip = styled(Chip)({
  borderRadius: 0,
  background: '#fafafa',
  border: '1px solid #d9d9d9',
  fontSize: 12,
  margin: '0 8px 0 0',
  padding: '5px 10px',
  transition: 'none',
  '& .MuiChip-label': {
    padding: '0',
  },
  '&:hover': {
    backgroundColor: 'var(--skyline-1)',
    border: '1px solid var(--grey-3)',
    color: 'var(--titan-blue-3)',
  },
  '&:active': {
    boxShadow: 'none',
  },
  '&.selected': {
    backgroundColor: 'var(--titan-blue-3)',
    color: 'var(--white)',
  },
});

const Tag = ({ children, ...otherProps }) => {
  return <RectangularChip label={children} {...otherProps} />;
};

export default Tag;
